import { call, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import axios from 'axios';

import { SubmissionError } from 'redux-form';

export function* registerUserSaga(action) {
  const { values, resolve, reject } = action.payload;
  try {
    const response = yield call(registerUser, values);

    if (response.data.result.isSuccessful) {
      yield call(resolve, true);
      yield put(push(`/activation?email=${encodeURIComponent(values.email)}`));
    } else {
      yield call(
        reject,
        new SubmissionError(response.data.result.errorMessage)
      );
    }
  } catch (error) {
    console.log(error.response);
    if (error.response && error.response.data.result) {
      yield call(
        reject,
        new SubmissionError(error.response.data.result.errorMessage)
      );
    } else {
      yield call(
        reject,
        new SubmissionError({ _error: JSON.stringify(error.response.data) })
      );
    }
  }
}

const registerUser = (values) => {
  return axios.post('/api/domain/registerTvpUser', values);
};
